import * as React from 'react';
import { InlineText2, TColors } from '@cian/ui-kit';
import { BulletList16 } from '@cian/ui-kit/prev';
import { clsx } from 'clsx';
import { TViewMode } from '../../containers/Projects/types';
import { TableIcon } from './TableIcon';
import * as styles from './ViewModeSwitch.css';

interface IViewModeSwitchProps {
  mode: TViewMode;
  onModeChange: (newMode: TViewMode) => void;
}

export function ViewModeSwitch(props: IViewModeSwitchProps) {
  const { mode, onModeChange } = props;
  const tileActiveColor: TColors | undefined = mode === 'table' ? 'primary_100' : undefined;
  const mapActiveColor: TColors | undefined = mode === 'list' ? 'primary_100' : undefined;

  const handleViewModeChange = React.useCallback(
    (type: TViewMode) => () => {
      onModeChange(type);
    },
    [onModeChange],
  );

  return (
    <div>
      <button className={styles['switch']} type="button" onClick={handleViewModeChange('table')}>
        <span className={clsx(styles['icon'], { [styles['active']]: mode === 'table' })}>
          <TableIcon />
        </span>
        <InlineText2 color={tileActiveColor}>Плитками</InlineText2>
      </button>
      <button className={styles['switch']} type="button" onClick={handleViewModeChange('list')}>
        <span className={clsx(styles['icon'], { [styles['active']]: mode === 'list' })}>
          <BulletList16 />
        </span>
        <InlineText2 color={mapActiveColor}>Списком</InlineText2>
      </button>
    </div>
  );
}
